const ProfileRoutes = {
  updatePicture: "/user/upload",
  updateProfile: "/user/update",
  getProfile: "/user/profile",
  PharmacyOrderList:"/marketplace/pharmacies/orders",
  PharmacyOrderUpdate:"/marketplace/pharmacies/orders/update",

}

export default ProfileRoutes